import React, { useState, useEffect } from 'react';
import '../App.css';

function DetectorsGeneral({ isOpen, onClose, onSelectDetector }) {
    const url = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    
    // Estados combinados
    const [detectors, setDetectors] = useState([]);
    const [noAuth, setNoAuth] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [manualIdent, setManualIdent] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [statusMsg, setStatusMsg] = useState({ text: "", type: "" });

    const showMessage = (text, type = "success") => {
        setStatusMsg({ text, type });
        setTimeout(() => setStatusMsg({ text: "", type: "" }), 4000);
    };

    const isDeviceOnline = (device) => {
        if (device.online !== undefined) return device.online;
        if (!device.lastConnection) return false;
        const diffInMinutes = (new Date() - new Date(device.lastConnection)) / 1000 / 60;
        return diffInMinutes < 2;
    };

    const formatTacticalDate = (isoString) => {
        if (!isoString) return "---";
        const date = new Date(isoString);
        if (isNaN(date)) return "---";
        const day = (0 + date.getDate().toString()).slice(-2);
        const month = (0 + (date.getMonth() + 1).toString()).slice(-2);
        const year = date.getFullYear().toString().slice(-2);
        const hours = (0 + date.getHours().toString()).slice(-2);
        const minutes = (0 + date.getMinutes().toString()).slice(-2);
        const seconds = (0 + date.getSeconds().toString()).slice(-2);
        return `${day}/${month}/${year} [${hours}:${minutes}:${seconds}]`;
    };

    // --- FETCH DE DATOS (Registrados y Pendientes) ---
    const fetchAllData = async () => {
        if (!isOpen) return;
        try {
            let options = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'x-access-token': token }
            };
            
            // 1. Equipos registrados
            let resDetectors = await fetch(url + '/', options);
            if (resDetectors.status === 401 || resDetectors.status === 403) {
                localStorage.removeItem('token');
                window.location.href = '/';
                return;
            }
            if (resDetectors.ok) setDetectors(await resDetectors.json());

            // 2. Equipos pendientes/intrusiones
            let resNoAuth = await fetch(url + '/noAuth', options);
            if (resNoAuth.ok) setNoAuth(await resNoAuth.json());

        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAllData();
        const timer = setInterval(() => {
            if (isOpen) fetchAllData();
        }, 5000);
        return () => clearInterval(timer);
    }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    // Filtrado del buscador
    const filteredDetectors = detectors.filter(det => {
        const term = searchTerm.toLowerCase();
        return (
            (det.ident && det.ident.toLowerCase().includes(term)) ||
            (det.alias && det.alias.toLowerCase().includes(term))
        );
    });

    const handleCardClick = (ident) => {
        localStorage.setItem("detSelected", ident); 
        if (onSelectDetector) onSelectDetector(ident); 
    };

    return (
        <div className={`alerts-page-wrapper ${isOpen ? 'open' : ''}`}>
            
            <div className="alerts-header">
                <h1 className="alerts-title" style={{fontSize: '18px'}}>
                    <i className="fa-solid fa-satellite-dish" style={{marginRight: '8px'}}></i> DEVICES
                </h1>
                <button className="btn-close-alerts" onClick={onClose}>
                    <i className="fa-solid fa-xmark"></i>
                </button>
                <input 
                    type="text" 
                    className="alerts-search-input" 
                    placeholder="Search ..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            {statusMsg.text && (
                <div style={{ padding: '8px', borderRadius: '8px', marginBottom: '15px', backgroundColor: statusMsg.type === 'error' ? 'rgba(255,0,0,0.2)' : 'rgba(0,255,0,0.2)', color: statusMsg.type === 'error' ? '#ff4444' : '#00ff00', border: `1px solid ${statusMsg.type === 'error' ? '#ff4444' : '#00ff00'}`, fontSize: '12px', textAlign: 'center', fontWeight: 'bold' }}>
                    {statusMsg.text}
                </div>
            )}

            {isLoading ? (
                <div style={{ textAlign: 'center', marginTop: '50px', color: '#888' }}>SCANNING NETWORK...</div>
            ) : (
                <div className="logs-grid">

                    {/* 1. SECCIÓN DIRECTORIO REGISTRADO */}
                    <div style={{ flex: 1 }}> {/* flex: 1 hace que esta zona empuje a la de abajo hacia el final */}
                        

                        {filteredDetectors.length === 0 ? (
                            <div style={{ textAlign: 'center', color: '#666', marginTop: '20px', fontSize: '12px' }}>
                                No registered devices.
                            </div>
                        ) : (
                            filteredDetectors
                            .sort((a, b) => {
                                // 1. (Opcional pero recomendado) Prioridad absoluta a los ONLINE
                                if (a.online && !b.online) return -1;
                                if (!a.online && b.online) return 1;
                                
                                // 2. Ordenar por el más reciente (el que tenga la fecha mayor)
                                // NOTA: Cambia 'lastConnection' por el nombre real de tu variable de fecha (ej: 'updatedAt' o 'timestamp')
                                return new Date(b.lastConnection || b.updatedAt) - new Date(a.lastConnection || a.updatedAt);
                            })
                            .map((det, index) => (
                                <div 
                                    key={index} 
                                    className={`asset-card ${isDeviceOnline(det) ? 'online' : 'offline'}`}
                                    onClick={() => handleCardClick(det.ident)}
                                    style={{ marginBottom: '12px' }}
                                >
                                    <div className="asset-header">
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span className="asset-id">{det.ident}</span>
                                            <span className="asset-alias">{det.alias || "No Alias"}</span>
                                        </div>
                                        <div className="asset-status-badges">
                                            <span className={`tactical-badge ${det.spoofing ? 'active' : ''}`}>
                                                {det.spoofing ? '🔥 SPOOFING' : 'STANDBY'}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <div className="log-footer" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span className="log-meta">Mode: {det.operationMode || "CUSTOM"}</span>
                                        <span className="log-date" title="Última conexión">
                                            <i className="fa-regular fa-clock" style={{marginRight: '5px'}}></i>
                                            {formatTacticalDate(det.lastConnection)}
                                        </span>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>

                </div>
            )}
        </div>
    );
}

export default DetectorsGeneral;